module.exports = __webpack_public_path__ + "static/media/bbc-storyworks-logo.40d2a068.png";